import { QuestionCompiled } from './question-compiled.model';

export class Section {
  SectionId: number
  QuestionsCompiled: QuestionCompiled[] = []
}
